import { Directive } from '@angular/core';

@Directive({
  selector: '[appModal]'
})
export class ModalDirective {

  constructor() { }

}
 